import './component.scss'

document.addEventListener('DOMContentLoaded', () => {
  const links = document.getElementsByClassName('js-ga-measure_target');

  Array.from(links).forEach(function(link) {
    link.addEventListener('click', function(event) {
      ga_datalayer_push(event)
    })
  })

  function ga_datalayer_push(event) {
    window.dataLayer = window.dataLayer || [];
    const now = new Date();
    const currentTime = now.toISOString().slice(0, 19).replace('T', ' ');
    window.dataLayer.push({
      event: 'floatingCompanyCardClick',
      floatingCompanyClickLinkUrl: event.target.closest('a').getAttribute('href'),
      floatingCompanyClickCurrentUrl: window.location.href,
      floatingCompanyClickCurrentTime: currentTime,
    });
  }
})
